import { Typography } from "@mui/material"
import React, { useContext } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper"
import { isDev } from "@theatticusapp/atticus-shared-components"
import { useAuthContext } from "../../../AuthContextWrapper"
import { SingleDateForm } from "../shared/SingleDateForm"
import { Estate } from "../../../models/Estate"
import { format } from "date-fns"
import { OUTCOMES } from "../../../constants"

export const DODScreen = (): JSX.Element => {
  const navigate = useNavigate()
  const { flow, activeEstate, setActiveEstate, user } = useAuthContext()
  const { screenName } = useParams()
  const currentScreen = flow?.getCurrentFlowScreen(screenName)

  const handleComplete = async (date: Date): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen")

    const estate = activeEstate || new Estate()
    // convert js date to mysql date
    estate.passedOn = format(date, "yyyy-MM-dd")

    try {
      await estate.saveEstate()
      setActiveEstate(estate)
    } catch (error) {
      throw new Error("could not save data")
    }

    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate)
    return true
  }

  const initDate = activeEstate?.passedOn
    ? // convert mysql date field to js date
      new Date(Date.parse(activeEstate.passedOn.replace(/-/g, "/")))
    : undefined

  return currentScreen ? (
    <FlowScreenWrapper
      title={`When did ${activeEstate?.deceasedFirstName} pass away?`}
      subTitle="A loved one’s date of death impacts the legal requirements and timeline for the estate."
    >
      <SingleDateForm
        initDate={initDate}
        minDate={new Date("1900-01-01")}
        maxDate={new Date()}
        isMaxDateToday={true}
        dateLabel="Date of death"
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : isDev ? (
    <Typography>could not determine current screen</Typography>
  ) : (
    <></>
  )
}
